import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  standalone: false,
  selector: 'mtn-map-toolbar-button',
  templateUrl: './map-toolbar-button.component.html',
  styleUrls: ['./map-toolbar-button.component.scss']
})
export class MapToolbarButtonComponent {

  @Output()
  toolbarClick = new EventEmitter<any>();
  @Input()
  imageIcon : string;
  @Input()
  badgeCount: number;
  @Input()
  color: 'grey' | 'green' | 'blue' | 'red' = 'grey';
  @Input()
  disabled = false;
  @Input()
  icon: IconProp;
  @Input()
  iconColor: 'default' | 'green' | 'red' = 'default';
  @Input()
  showEllipsis = false;

  constructor() {
  }

  handleClick(event: MouseEvent): void {
    if (!this.disabled) {
      this.toolbarClick.emit(event);
    }
  }

}
